import {t} from '@lingui/core/macro';

export const generateFirstName = ():string => {
    return getRandomVariant([
        t`Стремительный`,
        t`Бдительный`,
        t`Умный`,
        t`Счастливый`,
        t`Резвый`,
    ]);
};

export const generateLastName = ():string => {
    return getRandomVariant([
        t`Тигр`,
        t`Слоник`,
        t`Вомбат`,
        t`Котик`,
        t`Гепард`,
    ]);
};

export const getRandomVariant = (variants: string[]):string => {
    return variants[(Math.floor(Math.random() * variants.length))];
};